import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { PropertyProvider } from "./context/PropertyContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { PostProvider } from "./context/PostContext";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { PropertyInventoryProvider } from "./context/PropertyInventoryContext";
import { CompanyProvider } from "./context/CompanyContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const theme = createTheme({
  typography: {
    fontFamily: "Rubik, Arial, sans-serif",
    h6: { fontFamily: "Rubik, Playfair Display, serif" },
    subtitle1: { fontFamily: "Rubik, Montserrat, sans-serif" },
    body1: { fontFamily: "Rubik, sans-serif" },
    body2: { fontFamily: "Rubik, Montserrat, sans-serif" },
  },
});

// Configuración para manejar la recarga automática
let refreshing = false;
navigator.serviceWorker?.addEventListener('controllerchange', () => {
  if (!refreshing) {
    refreshing = true;
    window.location.reload();
  }
});

// Configuración del Service Worker
const onUpdate = (registration: ServiceWorkerRegistration) => {
  console.log('Nueva versión detectada. Actualizando...');
  if (registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
};

root.render(
  <ThemeProvider theme={theme}>
    <AuthProvider>
      <CurrencyProvider>
        <CompanyProvider>
          <PropertyProvider>
            <PostProvider>
              <PropertyInventoryProvider>
              <App />
              </PropertyInventoryProvider>
            </PostProvider>
          </PropertyProvider>
        </CompanyProvider>
      </CurrencyProvider>
    </AuthProvider>
  </ThemeProvider>
);

reportWebVitals();

// Registrar Service Worker solo en producción
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onUpdate: onUpdate
  });
} else {
  serviceWorkerRegistration.unregister();
}
